import { Form as AForm } from 'ant-design-vue/es/components';
import { computed, ref, watch } from 'vue';
export default {
  name: 'SelectEditor',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:value', 'blur', 'focus'],
  setup(props, context) {
    const formItemContext = AForm.useInjectFormItemContext();
    const isFocused = ref(false);
    const selectValue = ref(props.value);
    watch(() => props.value, val => {
      selectValue.value = val;
    }, {
      immediate: true
    });
    const handleBLur = e => {
      isFocused.value = false;
      context.emit('blur', e);
      formItemContext.onFieldBlur();
    };
    const handleFocus = e => {
      context.emit('focus', e);
      isFocused.value = true;
    };
    const handleUpdateValue = val => {
      context.emit('update:value', val);
    };
    const displayText = computed(() => {
      const idx = props.options.findIndex(t => t.value + '' === selectValue.value + '');
      if (idx === -1) return selectValue.value;
      return props.options[idx].label;
    });
    return {
      handleBLur,
      handleFocus,
      handleUpdateValue,
      isFocused,
      displayText,
      selectValue
    };
  }
};